import {useRoot} from '../../Root/hooks';

export default function useNotificationBadge(): number | undefined {
  const {
    notificationService: {counterOfNewNotifications},
  } = useRoot();
  return counterOfNewNotifications || undefined;
}
